export const MIN_NAME_LENGTH = 2;
export const MIN_PASSWORD_LENGTH = 8;
export const MIN_PASSWORD_STRENGTH = 40;
